import { UAParser } from 'ua-parser-js';

import { buildBrowserInfo, buildDeviceInfo, buildOSInfo } from '@pressreader/analytics-core';
import { IBrowserInfo, IDeviceInfo, IOSInfo, ISessionInfo } from '@pressreader/analytics-types';
import { getAnalyticsSessionId } from '@pressreader/analytics-utils';
import { getDocumentRefererClientSideFirst } from '@pressreader/utils';

interface IUserAgentInfo {
    deviceInfo: IDeviceInfo;
    osInfo: IOSInfo;
    browserInfo: IBrowserInfo;
    sessionInfo: ISessionInfo;
}

const ua = new UAParser().getResult();

const userAgentInfo: IUserAgentInfo = {
    deviceInfo: buildDeviceInfo(ua),
    osInfo: buildOSInfo(ua),
    browserInfo: buildBrowserInfo(ua),
    sessionInfo: { id: getAnalyticsSessionId(), referrer: getDocumentRefererClientSideFirst() },
};

export { IUserAgentInfo, userAgentInfo };
